import { teamServiceTypeMapping } from "./service-types";

export const teams = [
  { value: 'all', label: 'All Teams' },
  ...Object.keys(teamServiceTypeMapping).map((key) => {
    return { value: key, label: key };
  })
];
